import { Button } from "@/common/components/button";
import { DRFWrapper } from "./styles";
import Table from "@/common/components/Table";
import { Modal } from "@/common/components/modal";
import { useState } from "react";
import Form from "@/common/components/form/Form";
import { ModalWrapper } from "./styles";
import success from "../../../../assets/images/success_alt.png";
import { formInputs } from "./data";
import { TableData, TableHeaders } from "./data";

export default function DRF() {
  const [OpenModel, setOpenModel] = useState(false);
  const [redirectModal, setShowRedirectModal] = useState(false);

  const handleSubmit = (formValues: any) => {
    console.log("Form submitted with values:", formValues);
  };

  return (
    <DRFWrapper>
      <div className="invite-button">
        <Button onClick={() => setOpenModel(true)}> Invite User</Button>
      </div>
      <div className="teble">
        <Table
          tableTitle="Total Companies"
          submitLabel="70 Total Company"
          tableHeaders={TableHeaders}
          tableData={TableData}
        />
      </div>
      <div>
        <Modal
          title="Create User"
          isOpen={OpenModel}
          close={() => setOpenModel(false)}
        >
          <div className="modal">
            <Form formInputs={formInputs} processInputs={handleSubmit} />
          </div>
        </Modal>
        <Modal isOpen={redirectModal} close={() => setShowRedirectModal(false)}>
          <ModalWrapper>
            <img src={success} alt="success" />
            <p>User Successfully Create</p>

            <Button>Done</Button>
          </ModalWrapper>
        </Modal>
      </div>
    </DRFWrapper>
  );
}
